import { Stack } from '@ltvco/refresh-lib/theme';

import { MenuItem } from './MenuItem';

type NavigationSectionProps = {
  onAccountClick: () => void;
  onHelpClick: () => void;
  onFeedbackClick: () => void;
};

export const NavigationSection = ({
  onAccountClick,
  onHelpClick,
  onFeedbackClick,
}: NavigationSectionProps) => {
  return (
    <Stack sx={{ py: 1 }}>
      <MenuItem label="Account" onClick={onAccountClick} />
      <MenuItem label="Help" onClick={onHelpClick} />
      <MenuItem label="Send Feedback" onClick={onFeedbackClick} />
    </Stack>
  );
};
